
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import isknActualGetActions from '../../sagas/isknActual';
import { getToken } from '../../reducers/auth';
import { getKatuzeInfo } from '../../reducers/isknActual/';
import { getKatuzeInfoData } from '../../reducers/isknActual/katuzeInfo';
import { getProject, getProjectKatuzeItems } from '../../reducers/project';

import Text from '../../common/client/components/Text';

import IfElseComp from '../common/IfElseComp';
import IsknDataSetKatuzeInfos from './IsknDataSetKatuzeInfos';

const IsknActualInfo = () => {

    const dispatch = useDispatch();
    const isknActualActions = isknActualGetActions(dispatch);

    const token = useSelector(state => getToken(state.auth));
    const project = useSelector(state => getProject(state.project));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));
    const katuzeInfo = useSelector(state => getKatuzeInfo(state.isknActual));
    const katuzeInfoData = useSelector(state => getKatuzeInfoData(getKatuzeInfo(state.isknActual)));

    React.useEffect(() => {
        isknActualActions.getKatuzeInfo(
            token,
            project.id,
            projectKatuzeItems.map(item => item.kod)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <IfElseComp
            cond={katuzeInfo.loaded}
            trueComp={<IsknDataSetKatuzeInfos
                katuzeInfoData={katuzeInfoData}
                projectKatuzeItems={projectKatuzeItems}
            />}
            falseComp={<Text>Nahrávám data...</Text>}
        />
    );
}

export default IsknActualInfo;
